import { useMemo } from "react";
import { ImpostoDto } from "core/features/Imposto/typings/index";
import { Flex, Box, Text } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";

export default function useListagemImpostos() {
  return useMemo(() => {
    return [
      {
        title: "Imposto",
        width: "1200px",
        render: (original: ImpostoDto) => {
          return (
            <Box>
              <Text>{original.nome}</Text>
              <Text fontSize="11px" color={colors.darkGray}>
                {original.categoriaFinanceira}
              </Text>
            </Box>
          );
        },
      },
      {
        title: "Aliquota(%)",
        render: (original: ImpostoDto) => {
          return <Flex>{original.aliquota}</Flex>;
        },
      },
    ];
  }, []);
}
